import './component.scss'
import './images/tel_icon.svg'
import './images/rank1.svg'
import './images/rank2.svg'
import './images/rank3.svg'

import 'PackWerkNurikaeSite/pages/company_rankings/index/partials/company_area_info/component'
import 'PackWerkNurikaeSite/pages/company_rankings/index/partials/star_rating/component'
import 'PackWerkNurikaeSite/pages/company_rankings/index/partials/company_card/sp/image_container/component'
import 'PackWerkNurikaeSite/pages/company_rankings/index/partials/company_card/sp/cta/component'
import 'PackWerkNurikaeSite/pages/company_rankings/index/partials/clamp_text_with_link/component'

// ホバーアニメーション処理
document.addEventListener('DOMContentLoaded', () => {
  const companyLinkElements = document.querySelectorAll('.js-company-link')

  if (!companyLinkElements.length) return

  companyLinkElements.forEach((element) => {
    element.addEventListener('mouseover', () => element.classList.add('is-current'))
    element.addEventListener('mouseout', () => element.classList.remove('is-current'))
  })
})
